Ext.define('SA.CrosstabDataId', {
    statics: {
        get(tuple) {
            var key = tuple.slice().sort().join(''),
                cache = this.cache = (this.cache || new Map());

            if (!cache.has(key)) {
                cache.set(key, new SA.CrosstabDataId(tuple));
            }

            return cache.get(key);
        }
    },

    constructor(tuple) {
        this.tuple = Object.freeze(tuple);
    }
});